import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // App
      "app.title": "GAJ ONAS",
      "app.copyright": "Tous droits réservés",

      // Navigation
      "nav.dashboard": "Tableau de Bord",
      "nav.cases": "Affaires",
      "nav.foncier": "Foncier",
      "nav.contentieux": "Contentieux",
      "nav.assurances": "Assurances",
      "nav.contrats": "Contrats",
      "nav.documents": "Documents",
      "nav.logout": "Déconnexion",
      "nav.settings": "Paramètres",

      // Login
      "login.title": "Connexion",
      "login.username": "Nom d'utilisateur ou Email",
      "login.password": "Mot de passe",
      "login.submit": "Se connecter",
      "login.error": "Identifiants invalides",

      // Dashboard
      "dashboard.title": "Tableau de Bord",
      "dashboard.total_cases": "Total des Affaires",
      "dashboard.open_cases": "Affaires Ouvertes",
      "dashboard.closed_cases": "Affaires Clôturées",
      "dashboard.deadlines": "Échéances à venir",
      "dashboard.recentCases": "Affaires Récentes",
      "dashboard.upcomingDeadlines": "Prochaines Échéances",

      // Cases
      "cases.list": "Liste des Affaires",
      "cases.reference": "Référence",
      "cases.title": "Titre",
      "cases.type": "Type",
      "cases.status": "Statut",
      "cases.date": "Date",
      "cases.create": "Nouvelle Affaire",
      "cases.documents": "Documents",
      "cases.description": "Description",

      // Common
      "common.loading": "Chargement...",
      "common.error": "Erreur",
      "common.save": "Enregistrer",
      "common.saving": "Enregistrement...",
      "common.cancel": "Annuler",
      "common.add": "Ajouter",
      "common.edit": "Modifier",
      "common.delete": "Supprimer",
      "common.actions": "Actions",
      "common.noData": "Aucune donnée",
      "common.confirmDelete": "Confirmer la suppression?",
      "common.all": "Tous",
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.export": "Exporter",
      "common.refresh": "Actualiser",
      "common.select": "Sélectionner",
      "common.year": "Année",
      "common.close": "Fermer",
      "common.dismiss": "Fermer",
      "common.closeSidebar": "Fermer le menu",
      "common.openSidebar": "Ouvrir le menu",
      "search.title": "Recherche",
      "search.query": "Mots-clés",
      "search.placeholder": "Rechercher...",
      "search.search": "Rechercher",
      "search.filters": "Filtres",
      "search.applyFilters": "Appliquer les filtres",
      "search.noResults": "Aucun résultat",

      // Admin Section
      "admin.settings": "Paramètres du Système",
      "admin.users": "Utilisateurs",
      "admin.userManagement": "Gestion des Utilisateurs",
      "admin.roles": "Rôles",
      "admin.roleManagement": "Gestion des rôles",
      "admin.addRole": "Ajouter un rôle",
      "admin.editRole": "Modifier le rôle",
      "admin.roleCode": "Code",
      "admin.roleNameFr": "Nom (FR)",
      "admin.roleNameAr": "Nom (AR)",
      "admin.roleAdmin": "Accès admin",
      "admin.addUser": "Ajouter un Utilisateur",
      "admin.editUser": "Modifier l'Utilisateur",
      "admin.username": "Nom d'utilisateur",
      "admin.email": "Email",
      "admin.fullName": "Nom Complet",
      "admin.firstName": "Prénom",
      "admin.lastName": "Nom",
      "admin.role": "Rôle",
      "admin.selectRole": "Sélectionner un rôle",
      "admin.status": "Statut",
      "admin.active": "Actif",
      "admin.inactive": "Inactif",
      "admin.password": "Mot de passe",
      "admin.passwordRequirements": "Minimum 12 caractères",
      "admin.confirmDelete": "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
      "admin.userCreated": "Utilisateur créé avec succès",
      "admin.userUpdated": "Utilisateur mis à jour avec succès",
      "admin.userDeleted": "Utilisateur supprimé avec succès",
      "admin.userActivated": "Utilisateur activé",
      "admin.userDeactivated": "Utilisateur désactivé",
      "admin.userUnlocked": "Utilisateur déverrouillé",
      "admin.roleCreated": "Rôle créé",
      "admin.roleUpdated": "Rôle mis à jour",
      "admin.roleDeleted": "Rôle supprimé",
      "admin.accessRights": "Droits d'accès",
      "admin.clearOverrides": "Réinitialiser les exceptions",
      "admin.roleDefault": "Rôle",
      "admin.enabled": "Activé",
      "admin.disabled": "Désactivé",
      "admin.reset": "Réinitialiser",
      "admin.activate": "Activer",
      "admin.deactivate": "Désactiver",
      "admin.unlock": "Déverrouiller",
      "admin.loadError": "Erreur de chargement",
      "admin.saveError": "Erreur de sauvegarde",
      "admin.deleteError": "Erreur de suppression",
      "admin.toggleError": "Erreur de modification du statut",
      "admin.unlockError": "Erreur de déverrouillage",
      "admin.fillRequiredFields": "Veuillez remplir tous les champs obligatoires.",

      // Audit Log
      "admin.auditLog": "Journal d'Audit",
      "admin.action": "Action",
      "admin.model": "Modèle",
      "admin.object": "Objet",
      "admin.timestamp": "Date/Heure",
      "admin.ipAddress": "Adresse IP",
      "admin.user": "Utilisateur",
      "admin.exportLogs": "Exporter",
      "admin.exportError": "Erreur d'exportation",
      "admin.filterByAction": "Filtrer par action",
      "admin.filterByUser": "Filtrer par utilisateur",
      "admin.startDate": "Date de début",
      "admin.endDate": "Date de fin",

      // SMTP Settings
      "admin.emailSettings": "Configuration Email",
      "admin.smtpConfig": "Configuration SMTP",
      "admin.smtpHost": "Serveur SMTP",
      "admin.smtpPort": "Port",
      "admin.smtpUsername": "Nom d'utilisateur",
      "admin.smtpPassword": "Mot de passe",
      "admin.fromEmail": "Email d'envoi",
      "admin.useTls": "Utiliser TLS",
      "admin.sendTestEmail": "Envoyer un email test",
      "admin.testEmailSent": "Email test envoyé avec succès",
      "admin.testEmailFailed": "Échec de l'envoi de l'email test",
      "admin.settingsSaved": "Paramètres enregistrés avec succès",

      // Password Settings
      "admin.passwordSettings": "Politique de Mot de Passe",
      "admin.passwordPolicy": "Politique de Mot de Passe",
      "admin.minLength": "Longueur minimale",
      "admin.expiryDays": "Expiration (jours)",
      "admin.expiryDaysHelp": "0 = pas d'expiration",
      "admin.historyCount": "Historique (nombre)",
      "admin.maxAttempts": "Tentatives max",
      "admin.lockoutDuration": "Durée de verrouillage (minutes)",
      "admin.enablePasswordReset": "Activer la réinitialisation de mot de passe",

      // Notification Settings
      "admin.notificationSettings": "Paramètres des Notifications",
      "admin.enableEmailNotifications": "Activer les notifications par email",
      "admin.enableEmailNotificationsHelp": "Envoyer des notifications par email pour les actions importantes",
      "admin.enableDeadlineReminders": "Activer les rappels d'échéances",
      "admin.enableDeadlineRemindersHelp": "Envoyer des rappels avant les dates d'échéance",
      "admin.reminderDays": "Jours de rappel avant échéance",
      "admin.reminderDaysHelp": "Exemple: 7, 3, 1 (séparés par des virgules)",

      // Foncier
      "foncier.acquisitions": "Acquisitions",
      "foncier.expropriations": "Expropriations",
      "foncier.immatriculations": "Immatriculations",
      "foncier.servitudes": "Servitudes",
      "foncier.newAcquisition": "Nouvelle Acquisition",
      "foncier.newExpropriation": "Nouvelle Expropriation",
      "foncier.newImmatriculation": "Nouvelle Immatriculation",
      "foncier.newServitude": "Nouvelle Servitude",
      "foncier.landReference": "Réf. Terrain",
      "foncier.location": "Emplacement",
      "foncier.area": "Superficie",
      "foncier.stage": "Étape",
      "foncier.estimatedPrice": "Prix Estimé",
      "foncier.owner": "Propriétaire",
      "foncier.decreeNumber": "N° Décret",
      "foncier.decreeDate": "Date Décret",
      "foncier.publicUtilityPurpose": "Objet UP",
      "foncier.totalCompensation": "Indemnisation Totale",
      "foncier.cpfNumber": "N° CPF",
      "foncier.requisitionNumber": "N° Réquisition",
      "foncier.titleNumber": "N° Titre",
      "foncier.status": "Statut",
      "foncier.servitudeType": "Type de Servitude",
      "foncier.beneficiary": "Bénéficiaire",
      "foncier.description": "Description",

      // Contentieux
      "contentieux.cases": "Affaires",
      "contentieux.precontentieux": "Pré-contentieux",
      "contentieux.procedures": "Procédures",
      "contentieux.hearings": "Audiences",
      "contentieux.judgments": "Jugements",
      "contentieux.infractions": "Infractions",
      "contentieux.saisies": "Saisies",
      "contentieux.recouvrements": "Recouvrements",
      "contentieux.newCase": "Nouvelle Affaire",
      "contentieux.newPrecontentieux": "Nouveau Pré-contentieux",
      "contentieux.newProcedure": "Nouvelle Procédure",
      "contentieux.newHearing": "Nouvelle Audience",
      "contentieux.newJudgment": "Nouveau Jugement",
      "contentieux.newInfraction": "Nouvelle Infraction",
      "contentieux.newSaisie": "Nouvelle Saisie",
      "contentieux.newRecouvrement": "Nouveau Recouvrement",
      "contentieux.amountClaimed": "Montant Réclamé",
      "contentieux.debtor": "Débiteur",
      "contentieux.debtorName": "Nom du Débiteur",
      "contentieux.amountDue": "Montant Dû",
      "contentieux.stage": "Étape",
      "contentieux.lastActionDate": "Dernière Action",
      "contentieux.caseNumber": "N° Affaire",
      "contentieux.court": "Tribunal",
      "contentieux.instance": "Instance",
      "contentieux.hearingDate": "Date Audience",
      "contentieux.hearingType": "Type",
      "contentieux.outcome": "Résultat",
      "contentieux.judgmentDate": "Date Jugement",
      "contentieux.judgmentNumber": "N° Jugement",
      "contentieux.decision": "Décision",
      "contentieux.amountAwarded": "Montant Accordé",
      "contentieux.infractionType": "Type",
      "contentieux.offender": "Contrevenant",
      "contentieux.offenderName": "Nom du Contrevenant",
      "contentieux.discoveryDate": "Date Constat",
      "contentieux.penalty": "Amende",
      "contentieux.penaltyAmount": "Montant Amende",
      "contentieux.saisieType": "Type",
      "contentieux.amount": "Montant",
      "contentieux.totalAmount": "Montant Total",
      "contentieux.amountRecovered": "Montant Recouvré",
      "contentieux.remainingAmount": "Reste à Recouvrer",

      // Assurances
      "assurances.contracts": "Contrats",
      "assurances.sinistres": "Sinistres",
      "assurances.experts": "Experts",
      "assurances.expertises": "Expertises",
      "assurances.indemnisations": "Indemnisations",
      "assurances.attestations": "Attestations",
      "assurances.newContract": "Nouveau Contrat",
      "assurances.newSinistre": "Nouveau Sinistre",
      "assurances.newExpert": "Nouvel Expert",
      "assurances.newExpertise": "Nouvelle Expertise",
      "assurances.newIndemnisation": "Nouvelle Indemnisation",
      "assurances.newAttestation": "Nouvelle Attestation",
      "assurances.policyNumber": "N° Police",
      "assurances.insurer": "Assureur",
      "assurances.contractType": "Type de Contrat",
      "assurances.startDate": "Date Début",
      "assurances.endDate": "Date Fin",
      "assurances.premium": "Prime",
      "assurances.sinistreNumber": "N° Sinistre",
      "assurances.sinistreDate": "Date Sinistre",
      "assurances.description": "Description",
      "assurances.estimatedAmount": "Montant Estimé",
      "assurances.expertName": "Nom",
      "assurances.specialty": "Spécialité",
      "assurances.phone": "Téléphone",
      "assurances.email": "Email",
      "assurances.address": "Adresse",
      "assurances.expertiseDate": "Date Expertise",
      "assurances.expert": "Expert",
      "assurances.estimatedDamage": "Dommages Estimés",
      "assurances.findings": "Constatations",
      "assurances.recommendations": "Recommandations",
      "assurances.sinistre": "Sinistre",
      "assurances.proposedAmount": "Montant Proposé",
      "assurances.acceptedAmount": "Montant Accepté",
      "assurances.paymentDate": "Date Paiement",
      "assurances.notes": "Notes",
      "assurances.attestationType": "Type",
      "assurances.issueDate": "Date Émission",
      "assurances.requestedBy": "Demandeur",
      "assurances.purpose": "Objet",

      // Contrats
      "contrats.contrats": "Contrats",
      "contrats.locations": "Locations",
      "contrats.abonnements": "Abonnements",
      "contrats.vehicules": "Véhicules",
      "contrats.avenants": "Avenants",
      "contrats.renouvellements": "Renouvellements",
      "contrats.resiliations": "Résiliations",
      "contrats.echeances": "Échéances",
      "contrats.newContrat": "Nouveau Contrat",
      "contrats.newLocation": "Nouvelle Location",
      "contrats.newAbonnement": "Nouvel Abonnement",
      "contrats.newVehicule": "Nouveau Véhicule",
      "contrats.newAvenant": "Nouvel Avenant",
      "contrats.newRenouvellement": "Nouveau Renouvellement",
      "contrats.newResiliation": "Nouvelle Résiliation",
      "contrats.newEcheance": "Nouvelle Échéance",
      "contrats.contractNumber": "N° Contrat",
      "contrats.title": "Titre",
      "contrats.contractType": "Type",
      "contrats.counterparty": "Cocontractant",
      "contrats.startDate": "Date Début",
      "contrats.endDate": "Date Fin",
      "contrats.amount": "Montant",
      "contrats.propertyType": "Type de Bien",
      "contrats.address": "Adresse",
      "contrats.landlord": "Bailleur",
      "contrats.monthlyRent": "Loyer Mensuel",
      "contrats.deposit": "Caution",
      "contrats.serviceType": "Type de Service",
      "contrats.provider": "Fournisseur",
      "contrats.accountNumber": "N° Compte",
      "contrats.monthlyAmount": "Montant Mensuel",
      "contrats.vehicleType": "Type Contrat",
      "contrats.vehicleContractType": "Type Contrat",
      "contrats.brand": "Marque",
      "contrats.model": "Modèle",
      "contrats.registration": "Immatriculation",
      "contrats.monthlyPayment": "Paiement Mensuel",
      "contrats.avenantNumber": "N° Avenant",
      "contrats.avenantType": "Type",
      "contrats.effectiveDate": "Date Effet",
      "contrats.description": "Description",
      "contrats.contract": "Contrat",
      "contrats.renewalDate": "Date Renouvellement",
      "contrats.newEndDate": "Nouvelle Fin",
      "contrats.newAmount": "Nouveau Montant",
      "contrats.notes": "Notes",
      "contrats.resiliationReason": "Motif",
      "contrats.notificationDate": "Date Notification",
      "contrats.signatureDate": "Date Signature",
      "contrats.dueDate": "Date Échéance",
      "contrats.paymentDate": "Date Paiement",
      "contrats.noticePeriod": "Préavis (jours)",
      "contrats.landlord": "Bailleur",
      "contrats.counterparty": "Cocontractant",

      // Documents
      "documents.title": "Documents",
      "documents.allDocuments": "Tous les documents",
      "documents.upload": "Ajouter un document",
      "documents.preview": "Aperçu",
      "documents.file": "Fichier",
      "documents.category": "Catégorie",
      "documents.type": "Type",
      "documents.uploader": "Déposé par",
      "documents.date": "Date",
      "documents.description": "Description",
      "documents.caseType": "Type d'affaire",
      "documents.caseId": "Identifiant affaire",
      "documents.noDocuments": "Aucun document",
      "documents.noSelection": "Sélectionnez un document pour l'aperçu.",
      "documents.openFile": "Ouvrir le fichier dans un nouvel onglet",
      "documents.attachedTo": "Associé à",
      "documents.fileRequired": "Veuillez sélectionner un fichier.",
      "documents.titleRequired": "Veuillez saisir un titre.",
      "documents.categoryRequired": "Veuillez choisir une catégorie.",
      "documents.loadError": "Erreur de chargement des documents.",
      "documents.uploadError": "Erreur d'envoi du document.",
      "documents.uploadSuccess": "Document ajouté.",
      "documents.deleteError": "Erreur de suppression du document.",
      "documents.confirmDelete": "Supprimer ce document ?",
      "documents.download": "Télécharger",
      "documents.fileTooLarge": "Le fichier est trop volumineux. Taille max : {{maxSize}}",
      "documents.invalidFileType": "Type de fichier non valide. Types autorisés : {{extensions}}",
      "documents.noPreview": "Aperçu non disponible",
      "documents.previewError": "Erreur lors de l'aperçu",
      "documents.size": "Taille",
      "documents.pdfNotSupported": "L'aperçu PDF n'est pas pris en charge dans votre navigateur.",
      "documents.openInNewTab": "Ouvrir dans un nouvel onglet",
      "documents.officePreviewNotAvailable": "L'aperçu des documents Office n'est pas disponible.",
      "documents.downloadToView": "Téléchargez le fichier pour le visualiser.",

      // Activities
      "activities.title": "Activités",
      "activities.add": "Ajouter une activité",
      "activities.dueDate": "Date d'échéance",
      "activities.noActivities": "Aucune activité",

      // Auth (2FA & Password Reset)
      "auth.2faError": "Erreur de vérification 2FA",
      "auth.2faPrompt": "Un code de vérification a été envoyé à votre email. Veuillez le saisir ci-dessous.",
      "auth.verificationCode": "Code de vérification",
      "auth.verify": "Vérifier",
      "auth.forgotPassword": "Mot de passe oublié ?",
      "auth.forgotPasswordDesc": "Entrez votre email pour recevoir un lien de réinitialisation",
      "auth.forgotPasswordError": "Erreur lors de l'envoi du lien",
      "auth.sendResetLink": "Envoyer le lien",
      "auth.resetLinkSent": "Lien de réinitialisation envoyé",
      "auth.checkEmail": "Vérifiez votre email",
      "auth.backToLogin": "Retour à la connexion",
      "auth.resetPassword": "Réinitialiser le mot de passe",
      "auth.resetPasswordDesc": "Entrez votre nouveau mot de passe",
      "auth.resetPasswordError": "Erreur lors de la réinitialisation",
      "auth.newPassword": "Nouveau mot de passe",
      "auth.confirmPassword": "Confirmer le mot de passe",
      "auth.passwordRequirements": "Minimum 12 caractères",
      "auth.passwordTooShort": "Le mot de passe est trop court",
      "auth.passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
      "auth.passwordResetSuccess": "Mot de passe réinitialisé avec succès",
      "auth.redirectingToLogin": "Redirection vers la connexion...",
      "auth.email": "Email",

      // Admin additional
      "admin.2faEnabled": "2FA activée pour {{username}}",
      "admin.2faDisabled": "2FA désactivée pour {{username}}",
      "admin.2faToggleError": "Erreur lors du changement de 2FA",
      "admin.enable2FA": "Activer 2FA",
      "admin.disable2FA": "Désactiver 2FA",
      "admin.confirmPassword": "Confirmer le mot de passe",
      "admin.confirmSendResetLink": "Envoyer un lien de réinitialisation à {{email}} ?",
      "admin.newPassword": "Nouveau mot de passe",
      "admin.passwordMismatch": "Les mots de passe ne correspondent pas",
      "admin.passwordRequired": "Mot de passe requis",
      "admin.passwordTooShort": "Mot de passe trop court",
      "admin.passwordUpdated": "Mot de passe mis à jour pour {{username}}",
      "admin.passwordUpdateError": "Erreur de mise à jour du mot de passe",
      "admin.resetPassword": "Réinitialiser le mot de passe",
      "admin.resetPasswordTitle": "Réinitialiser le mot de passe",
      "admin.resetPasswordDesc": "Définir un nouveau mot de passe pour : {{username}}",
      "admin.resetLinkSent": "Lien de réinitialisation envoyé à {{email}}",
      "admin.resetLinkError": "Erreur lors de l'envoi du lien",
      "admin.sendResetLink": "Envoyer le lien de réinitialisation",
      "admin.setPassword": "Définir le mot de passe",
      "admin.testEmailConfig": "Tester la configuration email",
      "admin.testEmailDesc": "Envoyer un email de test pour vérifier la configuration SMTP",
      "admin.testEmailRecipient": "Email du destinataire",
      "admin.enterTestEmail": "Entrez l'email de test",
      "admin.frontendUrl": "URL du frontend",
      "admin.frontendUrlDesc": "URL de base pour les liens dans les emails",

      // Audit
      "audit.title": "Journal d'audit",

      // Cases additional
      "cases.activityLog": "Journal d'activité",
      "cases.activityTitle": "Titre",
      "cases.activityType": "Type",
      "cases.activityDate": "Date",
      "cases.activityDescription": "Description",
      "cases.addActivity": "Ajouter une activité",
      "cases.addComment": "Ajouter un commentaire",
      "cases.addNote": "Ajouter une note",
      "cases.addTask": "Ajouter une tâche",
      "cases.assignee": "Assigné à",
      "cases.closedDate": "Date de clôture",
      "cases.comment": "Commentaire",
      "cases.comments": "Commentaires",
      "cases.currentStage": "Étape actuelle",
      "cases.dueDate": "Date d'échéance",
      "cases.followUp": "Suivi",
      "cases.meeting": "Réunion",
      "cases.message": "Message",
      "cases.noActivities": "Aucune activité",
      "cases.noActivity": "Aucune activité",
      "cases.noComments": "Aucun commentaire",
      "cases.noTasks": "Aucune tâche",
      "cases.notFound": "Affaire non trouvée",
      "cases.note": "Note",
      "cases.noteType": "Type de note",
      "cases.openedDate": "Date d'ouverture",
      "cases.reminder": "Rappel",
      "cases.saveStage": "Enregistrer l'étape",
      "cases.schedule": "Planifier",
      "cases.stage": "Étape",
      "cases.taskDescription": "Description de la tâche",
      "cases.taskTitle": "Titre de la tâche",
      "cases.tasks": "Tâches",
      "cases.transitionCommentTitle": "Commentaire de transition",
      "cases.transitionCommentMessage": "Ajoutez un commentaire pour cette transition",
      "cases.updateStage": "Mettre à jour l'étape",
      "cases.workflow": "Workflow",
      "cases.availableTransitions": "Transitions disponibles",
      "cases.moveTo": "Passer à",
      "cases.requiresComment": "commentaire requis",
      "cases.details": "Détails de l'affaire",
      "cases.stageChanged": "Étape changée vers {{stage}}",
      "cases.stageChangeError": "Erreur lors du changement d'étape",
      "cases.edit": "Modifier l'affaire",
      "cases.updated": "Affaire mise à jour avec succès",
      "cases.loadError": "Erreur de chargement de l'affaire",
      "cases.assignedTo": "Assigné à",

      // Common additional
      "common.active": "Actif",
      "common.inactive": "Inactif",
      "common.addComment": "Ajouter un commentaire",
      "common.allStages": "Toutes les étapes",
      "common.back": "Retour",
      "common.comment": "Commentaire",
      "common.confirm": "Confirmer",
      "common.filterByStage": "Filtrer par étape",
      "common.itemsPerPage": "Éléments par page",
      "common.next": "Suivant",
      "common.previous": "Précédent",
      "common.results": "résultats",
      "common.showing": "Affichage",
      "common.noDescription": "Pas de description",
      "common.noMatchingData": "Aucune donnée correspondante",
      "common.unassigned": "Non assigné",
      "common.unknown": "Inconnu",
      "common.system": "Système",

      // Audit Actions
      "audit.actionCreate": "Création",
      "audit.actionUpdate": "Modification",
      "audit.actionDelete": "Suppression",
      "audit.actionView": "Consultation",

      // Module titles
      "foncier": "Foncier",
      "contentieux": "Contentieux",
      "assurances": "Assurances",
      "contrats": "Contrats",

      // Contentieux additional
      "contentieux.nextHearingDate": "Prochaine audience",

      // Tasks
      "tasks.statusOpen": "Ouvert",
      "tasks.statusInProgress": "En cours",
      "tasks.statusCompleted": "Terminé",

      // Status
      "status.open": "Ouvert",
      "status.inProgress": "En cours",
      "status.pending": "En attente",
      "status.closed": "Clôturé",

      // Cases Kanban
      "cases.kanban": "Tableau Kanban des Affaires",

      // Document Categories
      "documents.categoryGeneral": "Général",
      "documents.categoryCase": "Affaire",
      "documents.categoryContract": "Contrat",
      "documents.categoryAudit": "Audit",
      "documents.categoryOther": "Autre",

      // Permissions
      "permissions.viewDashboard": "Voir le tableau de bord",
      "permissions.viewCases": "Voir les affaires",
      "permissions.createCases": "Créer des affaires",
      "permissions.editCases": "Modifier les affaires",
      "permissions.deleteCases": "Supprimer les affaires",
      "permissions.viewFoncier": "Voir le foncier",
      "permissions.createFoncier": "Créer des enregistrements fonciers",
      "permissions.editFoncier": "Modifier les enregistrements fonciers",
      "permissions.deleteFoncier": "Supprimer les enregistrements fonciers",
      "permissions.viewContentieux": "Voir le contentieux",
      "permissions.createContentieux": "Créer des enregistrements contentieux",
      "permissions.editContentieux": "Modifier les enregistrements contentieux",
      "permissions.deleteContentieux": "Supprimer les enregistrements contentieux",
      "permissions.viewAssurances": "Voir les assurances",
      "permissions.createAssurances": "Créer des enregistrements assurances",
      "permissions.editAssurances": "Modifier les enregistrements assurances",
      "permissions.deleteAssurances": "Supprimer les enregistrements assurances",
      "permissions.viewContrats": "Voir les contrats",
      "permissions.createContrats": "Créer des enregistrements contrats",
      "permissions.editContrats": "Modifier les enregistrements contrats",
      "permissions.deleteContrats": "Supprimer les enregistrements contrats",
      "permissions.viewDocuments": "Voir les documents",
      "permissions.uploadDocuments": "Téléverser des documents",
      "permissions.deleteDocuments": "Supprimer des documents",
      "permissions.viewWorkflows": "Voir les workflows",
      "permissions.createWorkflows": "Créer des workflows",
      "permissions.editWorkflows": "Modifier les workflows",
      "permissions.deleteWorkflows": "Supprimer les workflows",
      "permissions.manageStages": "Gérer les étapes",
      "permissions.manageTransitions": "Gérer les transitions",
      "permissions.accessAdmin": "Accéder aux paramètres admin",
      "permissions.manageUsers": "Gérer les utilisateurs",
      "permissions.manageRoles": "Gérer les rôles",
      "permissions.resetPassword": "Réinitialiser le mot de passe directement",
      "permissions.sendResetLink": "Envoyer un lien de réinitialisation",
      "permissions.managePermissions": "Gérer les permissions",

      // Profile
      "profile.title": "Profil",
      "profile.description": "Gérez vos informations personnelles",
      "profile.accountInfo": "Informations du compte",
      "profile.accountStatus": "Statut du compte",
      "profile.email": "Email",
      "profile.phone": "Téléphone",
      "profile.department": "Département",
      "profile.role": "Rôle",
      "profile.lastLogin": "Dernière connexion",
      "profile.active": "Actif",
      "profile.inactive": "Inactif",
      "profile.enabled": "Activé",
      "profile.disabled": "Désactivé",
      "profile.enable": "Activer",
      "profile.disable": "Désactiver",
      "profile.twoFactorAuth": "Authentification à deux facteurs",
      "profile.twoFactorStatus": "Statut 2FA",
      "profile.2faEnabled": "2FA activée",
      "profile.2faEnabledDesc": "Votre compte est protégé par l'authentification à deux facteurs",
      "profile.2faDisabled": "2FA désactivée",
      "profile.2faDisabledDesc": "Activez 2FA pour plus de sécurité",
      "profile.2faActive": "2FA active",
      "profile.2faActiveDesc": "Protection supplémentaire activée",
      "profile.2faError": "Erreur lors du changement de 2FA",
      "profile.emailVerification": "Vérification de l'email",

      // Workflows
      "workflows.title": "Workflows",
      "workflows.management": "Gestion des workflows",
      "workflows.list": "Liste des workflows",
      "workflows.create": "Créer un workflow",
      "workflows.name": "Nom",
      "workflows.nameFr": "Nom (FR)",
      "workflows.nameAr": "Nom (AR)",
      "workflows.description": "Description",
      "workflows.entityType": "Type d'entité",
      "workflows.status": "Statut",
      "workflows.stages": "Étapes",
      "workflows.transitions": "Transitions",
      "workflows.addStage": "Ajouter une étape",
      "workflows.editStage": "Modifier l'étape",
      "workflows.addTransition": "Ajouter une transition",
      "workflows.editTransition": "Modifier la transition",
      "workflows.stageCode": "Code de l'étape",
      "workflows.color": "Couleur",
      "workflows.order": "Ordre",
      "workflows.initial": "Initial",
      "workflows.final": "Final",
      "workflows.folded": "Replié",
      "workflows.isInitial": "Est initial",
      "workflows.isFinal": "Est final",
      "workflows.isFolded": "Est replié",
      "workflows.fromStage": "De l'étape",
      "workflows.toStage": "Vers l'étape",
      "workflows.requiresComment": "Commentaire requis",
      "workflows.requiresAttachments": "Pièces jointes requises",
      "workflows.noStages": "Aucune étape",
      "workflows.noTransitions": "Aucune transition",
      "workflows.confirmDeleteStage": "Supprimer cette étape ?",
      "workflows.confirmDeleteTransition": "Supprimer cette transition ?",
      "workflows.stageCreated": "Étape créée",
      "workflows.stageUpdated": "Étape mise à jour",
      "workflows.stageDeleted": "Étape supprimée",
      "workflows.stageReordered": "Étapes réordonnées",
      "workflows.transitionCreated": "Transition créée",
      "workflows.transitionUpdated": "Transition mise à jour",
      "workflows.transitionDeleted": "Transition supprimée",
      "workflows.notFound": "Workflow non trouvé",
      "workflows.info": "Informations",
      "workflows.info1": "Les workflows définissent le cycle de vie des affaires",
      "workflows.info2": "Chaque étape représente un état de l'affaire",
      "workflows.info3": "Les transitions définissent les passages possibles entre étapes",
      "workflows.info4": "L'ordre des étapes détermine leur affichage",

      // Colors
      "colors.gray": "Gris",
      "colors.red": "Rouge",
      "colors.orange": "Orange",
      "colors.yellow": "Jaune",
      "colors.green": "Vert",
      "colors.blue": "Bleu",
      "colors.indigo": "Indigo",
      "colors.purple": "Violet",
      "colors.pink": "Rose"
    }
  },
  ar: {
    translation: {
      // App
      "app.title": "نظام إدارة الشؤون القانونية",
      "app.copyright": "جميع الحقوق محفوظة",

      // Navigation
      "nav.dashboard": "لوحة القيادة",
      "nav.cases": "القضايا",
      "nav.foncier": "الأملاك العقارية",
      "nav.contentieux": "المنازعات",
      "nav.assurances": "التأمينات",
      "nav.contrats": "العقود",
      "nav.documents": "المستندات",
      "nav.logout": "تسجيل الخروج",
      "nav.settings": "الإعدادات",

      // Login
      "login.title": "تسجيل الدخول",
      "login.username": "اسم المستخدم أو البريد الإلكتروني",
      "login.password": "كلمة المرور",
      "login.submit": "دخول",
      "login.error": "بيانات الاعتماد غير صالحة",

      // Dashboard
      "dashboard.title": "لوحة القيادة",
      "dashboard.total_cases": "مجموع القضايا",
      "dashboard.open_cases": "القضايا المفتوحة",
      "dashboard.closed_cases": "القضايا المغلقة",
      "dashboard.deadlines": "المواعيد القادمة",
      "dashboard.recentCases": "القضايا الأخيرة",
      "dashboard.upcomingDeadlines": "المواعيد القادمة",

      // Cases
      "cases.list": "قائمة القضايا",
      "cases.reference": "المرجع",
      "cases.title": "العنوان",
      "cases.type": "النوع",
      "cases.status": "الحالة",
      "cases.date": "التاريخ",
      "cases.create": "قضية جديدة",
      "cases.documents": "المستندات",
      "cases.description": "الوصف",

      // Common
      "common.loading": "جاري التحميل...",
      "common.error": "خطأ",
      "common.save": "حفظ",
      "common.saving": "جاري الحفظ...",
      "common.cancel": "إلغاء",
      "common.add": "إضافة",
      "common.edit": "تعديل",
      "common.delete": "حذف",
      "common.actions": "الإجراءات",
      "common.noData": "لا توجد بيانات",
      "common.confirmDelete": "تأكيد الحذف؟",
      "common.all": "الكل",
      "common.search": "بحث",
      "common.filter": "تصفية",
      "common.export": "تصدير",
      "common.refresh": "تحديث",
      "common.select": "اختيار",
      "common.year": "السنة",
      "common.close": "إغلاق",
      "common.dismiss": "إغلاق",
      "common.closeSidebar": "إغلاق القائمة",
      "common.openSidebar": "فتح القائمة",
      "search.title": "بحث",
      "search.query": "كلمات البحث",
      "search.placeholder": "ابحث...",
      "search.search": "بحث",
      "search.filters": "الفلاتر",
      "search.applyFilters": "تطبيق الفلاتر",
      "search.noResults": "لا توجد نتائج",

      // Admin Section
      "admin.settings": "إعدادات النظام",
      "admin.users": "المستخدمون",
      "admin.userManagement": "إدارة المستخدمين",
      "admin.roles": "الأدوار",
      "admin.roleManagement": "إدارة الأدوار",
      "admin.addRole": "إضافة دور",
      "admin.editRole": "تعديل الدور",
      "admin.roleCode": "الرمز",
      "admin.roleNameFr": "الاسم (FR)",
      "admin.roleNameAr": "الاسم (AR)",
      "admin.roleAdmin": "وصول الإدارة",
      "admin.addUser": "إضافة مستخدم",
      "admin.editUser": "تعديل المستخدم",
      "admin.username": "اسم المستخدم",
      "admin.email": "البريد الإلكتروني",
      "admin.fullName": "الاسم الكامل",
      "admin.firstName": "الاسم الأول",
      "admin.lastName": "اسم العائلة",
      "admin.role": "الدور",
      "admin.selectRole": "اختر دورًا",
      "admin.status": "الحالة",
      "admin.active": "نشط",
      "admin.inactive": "غير نشط",
      "admin.password": "كلمة المرور",
      "admin.passwordRequirements": "12 حرفًا كحد أدنى",
      "admin.confirmDelete": "هل أنت متأكد من حذف هذا المستخدم؟",
      "admin.userCreated": "تم إنشاء المستخدم بنجاح",
      "admin.userUpdated": "تم تحديث المستخدم بنجاح",
      "admin.userDeleted": "تم حذف المستخدم بنجاح",
      "admin.userActivated": "تم تفعيل المستخدم",
      "admin.userDeactivated": "تم تعطيل المستخدم",
      "admin.userUnlocked": "تم إلغاء قفل المستخدم",
      "admin.roleCreated": "تم إنشاء الدور",
      "admin.roleUpdated": "تم تحديث الدور",
      "admin.roleDeleted": "تم حذف الدور",
      "admin.accessRights": "صلاحيات الوصول",
      "admin.clearOverrides": "إزالة الاستثناءات",
      "admin.roleDefault": "الدور",
      "admin.enabled": "مفعل",
      "admin.disabled": "معطل",
      "admin.reset": "إعادة ضبط",
      "admin.activate": "تفعيل",
      "admin.deactivate": "تعطيل",
      "admin.unlock": "إلغاء القفل",
      "admin.loadError": "خطأ في التحميل",
      "admin.saveError": "خطأ في الحفظ",
      "admin.deleteError": "خطأ في الحذف",
      "admin.toggleError": "خطأ في تغيير الحالة",
      "admin.unlockError": "خطأ في إلغاء القفل",
      "admin.fillRequiredFields": "يرجى ملء جميع الحقول المطلوبة.",

      // Audit Log
      "admin.auditLog": "سجل التدقيق",
      "admin.action": "الإجراء",
      "admin.model": "النموذج",
      "admin.object": "الكائن",
      "admin.timestamp": "التاريخ/الوقت",
      "admin.ipAddress": "عنوان IP",
      "admin.user": "المستخدم",
      "admin.exportLogs": "تصدير",
      "admin.exportError": "خطأ في التصدير",
      "admin.filterByAction": "تصفية حسب الإجراء",
      "admin.filterByUser": "تصفية حسب المستخدم",
      "admin.startDate": "تاريخ البداية",
      "admin.endDate": "تاريخ النهاية",

      // SMTP Settings
      "admin.emailSettings": "إعدادات البريد الإلكتروني",
      "admin.smtpConfig": "إعدادات SMTP",
      "admin.smtpHost": "خادم SMTP",
      "admin.smtpPort": "المنفذ",
      "admin.smtpUsername": "اسم المستخدم",
      "admin.smtpPassword": "كلمة المرور",
      "admin.fromEmail": "البريد المرسل",
      "admin.useTls": "استخدام TLS",
      "admin.sendTestEmail": "إرسال بريد تجريبي",
      "admin.testEmailSent": "تم إرسال البريد التجريبي بنجاح",
      "admin.testEmailFailed": "فشل إرسال البريد التجريبي",
      "admin.settingsSaved": "تم حفظ الإعدادات بنجاح",

      // Password Settings
      "admin.passwordSettings": "سياسة كلمة المرور",
      "admin.passwordPolicy": "سياسة كلمة المرور",
      "admin.minLength": "الحد الأدنى للطول",
      "admin.expiryDays": "انتهاء الصلاحية (أيام)",
      "admin.expiryDaysHelp": "0 = بدون انتهاء صلاحية",
      "admin.historyCount": "تاريخ كلمات المرور",
      "admin.maxAttempts": "أقصى محاولات",
      "admin.lockoutDuration": "مدة القفل (دقائق)",
      "admin.enablePasswordReset": "تمكين إعادة تعيين كلمة المرور",

      // Notification Settings
      "admin.notificationSettings": "إعدادات الإشعارات",
      "admin.enableEmailNotifications": "تفعيل إشعارات البريد الإلكتروني",
      "admin.enableEmailNotificationsHelp": "إرسال إشعارات بالبريد الإلكتروني للإجراءات المهمة",
      "admin.enableDeadlineReminders": "تفعيل تذكيرات المواعيد",
      "admin.enableDeadlineRemindersHelp": "إرسال تذكيرات قبل تواريخ الاستحقاق",
      "admin.reminderDays": "أيام التذكير قبل الموعد",
      "admin.reminderDaysHelp": "مثال: 7، 3، 1 (مفصولة بفواصل)",

      // Foncier
      "foncier.acquisitions": "الاستحواذات",
      "foncier.expropriations": "نزع الملكية",
      "foncier.immatriculations": "التسجيل العقاري",
      "foncier.servitudes": "حقوق الارتفاق",
      "foncier.newAcquisition": "استحواذ جديد",
      "foncier.newExpropriation": "نزع ملكية جديد",
      "foncier.newImmatriculation": "تسجيل عقاري جديد",
      "foncier.newServitude": "حق ارتفاق جديد",
      "foncier.landReference": "مرجع الأرض",
      "foncier.location": "الموقع",
      "foncier.area": "المساحة",
      "foncier.stage": "المرحلة",
      "foncier.estimatedPrice": "السعر التقديري",
      "foncier.owner": "المالك",
      "foncier.decreeNumber": "رقم المرسوم",
      "foncier.decreeDate": "تاريخ المرسوم",
      "foncier.publicUtilityPurpose": "الغرض العام",
      "foncier.totalCompensation": "التعويض الكلي",
      "foncier.cpfNumber": "رقم CPF",
      "foncier.requisitionNumber": "رقم الطلب",
      "foncier.titleNumber": "رقم الصك",
      "foncier.status": "الحالة",
      "foncier.servitudeType": "نوع الارتفاق",
      "foncier.beneficiary": "المستفيد",
      "foncier.description": "الوصف",

      // Contentieux
      "contentieux.cases": "القضايا",
      "contentieux.precontentieux": "ما قبل النزاع",
      "contentieux.procedures": "الإجراءات",
      "contentieux.hearings": "الجلسات",
      "contentieux.judgments": "الأحكام",
      "contentieux.infractions": "المخالفات",
      "contentieux.saisies": "الحجوزات",
      "contentieux.recouvrements": "التحصيلات",
      "contentieux.newCase": "قضية جديدة",
      "contentieux.newPrecontentieux": "ما قبل نزاع جديد",
      "contentieux.newProcedure": "إجراء جديد",
      "contentieux.newHearing": "جلسة جديدة",
      "contentieux.newJudgment": "حكم جديد",
      "contentieux.newInfraction": "مخالفة جديدة",
      "contentieux.newSaisie": "حجز جديد",
      "contentieux.newRecouvrement": "تحصيل جديد",
      "contentieux.amountClaimed": "المبلغ المطالب به",
      "contentieux.debtor": "المدين",
      "contentieux.debtorName": "اسم المدين",
      "contentieux.amountDue": "المبلغ المستحق",
      "contentieux.stage": "المرحلة",
      "contentieux.lastActionDate": "آخر إجراء",
      "contentieux.caseNumber": "رقم القضية",
      "contentieux.court": "المحكمة",
      "contentieux.instance": "الدرجة",
      "contentieux.hearingDate": "تاريخ الجلسة",
      "contentieux.hearingType": "النوع",
      "contentieux.outcome": "النتيجة",
      "contentieux.judgmentDate": "تاريخ الحكم",
      "contentieux.judgmentNumber": "رقم الحكم",
      "contentieux.decision": "القرار",
      "contentieux.amountAwarded": "المبلغ المحكوم به",
      "contentieux.infractionType": "النوع",
      "contentieux.offender": "المخالف",
      "contentieux.offenderName": "اسم المخالف",
      "contentieux.discoveryDate": "تاريخ الاكتشاف",
      "contentieux.penalty": "الغرامة",
      "contentieux.penaltyAmount": "مبلغ الغرامة",
      "contentieux.saisieType": "النوع",
      "contentieux.amount": "المبلغ",
      "contentieux.totalAmount": "المبلغ الكلي",
      "contentieux.amountRecovered": "المبلغ المحصل",
      "contentieux.remainingAmount": "المبلغ المتبقي",

      // Assurances
      "assurances.contracts": "العقود",
      "assurances.sinistres": "الحوادث",
      "assurances.experts": "الخبراء",
      "assurances.expertises": "الخبرات",
      "assurances.indemnisations": "التعويضات",
      "assurances.attestations": "الشهادات",
      "assurances.newContract": "عقد جديد",
      "assurances.newSinistre": "حادث جديد",
      "assurances.newExpert": "خبير جديد",
      "assurances.newExpertise": "خبرة جديدة",
      "assurances.newIndemnisation": "تعويض جديد",
      "assurances.newAttestation": "شهادة جديدة",
      "assurances.policyNumber": "رقم البوليصة",
      "assurances.insurer": "شركة التأمين",
      "assurances.contractType": "نوع العقد",
      "assurances.startDate": "تاريخ البداية",
      "assurances.endDate": "تاريخ النهاية",
      "assurances.premium": "القسط",
      "assurances.sinistreNumber": "رقم الحادث",
      "assurances.sinistreDate": "تاريخ الحادث",
      "assurances.description": "الوصف",
      "assurances.estimatedAmount": "المبلغ التقديري",
      "assurances.expertName": "الاسم",
      "assurances.specialty": "التخصص",
      "assurances.phone": "الهاتف",
      "assurances.email": "البريد الإلكتروني",
      "assurances.address": "العنوان",
      "assurances.expertiseDate": "تاريخ الخبرة",
      "assurances.expert": "الخبير",
      "assurances.estimatedDamage": "الأضرار التقديرية",
      "assurances.findings": "الملاحظات",
      "assurances.recommendations": "التوصيات",
      "assurances.sinistre": "الحادث",
      "assurances.proposedAmount": "المبلغ المقترح",
      "assurances.acceptedAmount": "المبلغ المقبول",
      "assurances.paymentDate": "تاريخ الدفع",
      "assurances.notes": "ملاحظات",
      "assurances.attestationType": "النوع",
      "assurances.issueDate": "تاريخ الإصدار",
      "assurances.requestedBy": "طالب الشهادة",
      "assurances.purpose": "الغرض",

      // Contrats
      "contrats.contrats": "العقود",
      "contrats.locations": "الإيجارات",
      "contrats.abonnements": "الاشتراكات",
      "contrats.vehicules": "المركبات",
      "contrats.avenants": "الملاحق",
      "contrats.renouvellements": "التجديدات",
      "contrats.resiliations": "الإنهاءات",
      "contrats.echeances": "الاستحقاقات",
      "contrats.newContrat": "عقد جديد",
      "contrats.newLocation": "إيجار جديد",
      "contrats.newAbonnement": "اشتراك جديد",
      "contrats.newVehicule": "مركبة جديدة",
      "contrats.newAvenant": "ملحق جديد",
      "contrats.newRenouvellement": "تجديد جديد",
      "contrats.newResiliation": "إنهاء جديد",
      "contrats.newEcheance": "استحقاق جديد",
      "contrats.contractNumber": "رقم العقد",
      "contrats.title": "العنوان",
      "contrats.contractType": "النوع",
      "contrats.counterparty": "الطرف الآخر",
      "contrats.startDate": "تاريخ البداية",
      "contrats.endDate": "تاريخ النهاية",
      "contrats.amount": "المبلغ",
      "contrats.propertyType": "نوع العقار",
      "contrats.address": "العنوان",
      "contrats.landlord": "المؤجر",
      "contrats.monthlyRent": "الإيجار الشهري",
      "contrats.deposit": "الضمان",
      "contrats.serviceType": "نوع الخدمة",
      "contrats.provider": "المزود",
      "contrats.accountNumber": "رقم الحساب",
      "contrats.monthlyAmount": "المبلغ الشهري",
      "contrats.vehicleType": "نوع العقد",
      "contrats.vehicleContractType": "نوع العقد",
      "contrats.brand": "الماركة",
      "contrats.model": "الموديل",
      "contrats.registration": "رقم التسجيل",
      "contrats.monthlyPayment": "الدفع الشهري",
      "contrats.avenantNumber": "رقم الملحق",
      "contrats.avenantType": "النوع",
      "contrats.effectiveDate": "تاريخ السريان",
      "contrats.description": "الوصف",
      "contrats.contract": "العقد",
      "contrats.renewalDate": "تاريخ التجديد",
      "contrats.newEndDate": "تاريخ النهاية الجديد",
      "contrats.newAmount": "المبلغ الجديد",
      "contrats.notes": "ملاحظات",
      "contrats.resiliationReason": "السبب",
      "contrats.notificationDate": "تاريخ الإخطار",
      "contrats.signatureDate": "تاريخ التوقيع",
      "contrats.dueDate": "تاريخ الاستحقاق",
      "contrats.paymentDate": "تاريخ الدفع",
      "contrats.noticePeriod": "مدة الإشعار (أيام)",
      "contrats.landlord": "المؤجر",
      "contrats.counterparty": "الطرف الآخر",

      // Documents
      "documents.title": "المستندات",
      "documents.allDocuments": "كل المستندات",
      "documents.upload": "إضافة مستند",
      "documents.preview": "معاينة",
      "documents.file": "الملف",
      "documents.category": "التصنيف",
      "documents.type": "النوع",
      "documents.uploader": "تم الرفع بواسطة",
      "documents.date": "التاريخ",
      "documents.description": "الوصف",
      "documents.caseType": "نوع القضية",
      "documents.caseId": "معرف القضية",
      "documents.noDocuments": "لا توجد مستندات",
      "documents.noSelection": "اختر مستندًا للمعاينة هنا.",
      "documents.openFile": "فتح الملف في علامة تبويب جديدة",
      "documents.attachedTo": "مرتبط بـ",
      "documents.fileRequired": "يرجى اختيار ملف.",
      "documents.titleRequired": "يرجى إدخال عنوان.",
      "documents.categoryRequired": "يرجى اختيار تصنيف.",
      "documents.loadError": "فشل تحميل المستندات.",
      "documents.uploadError": "فشل رفع المستند.",
      "documents.uploadSuccess": "تمت إضافة المستند.",
      "documents.deleteError": "فشل حذف المستند.",
      "documents.confirmDelete": "هل تريد حذف هذا المستند؟",
      "documents.download": "تنزيل",
      "documents.fileTooLarge": "الملف كبير جداً. الحجم الأقصى: {{maxSize}}",
      "documents.invalidFileType": "نوع الملف غير صالح. الأنواع المسموحة: {{extensions}}",
      "documents.noPreview": "المعاينة غير متاحة",
      "documents.previewError": "خطأ في المعاينة",
      "documents.size": "الحجم",
      "documents.pdfNotSupported": "معاينة PDF غير مدعومة في متصفحك.",
      "documents.openInNewTab": "فتح في علامة تبويب جديدة",
      "documents.officePreviewNotAvailable": "معاينة مستندات Office غير متاحة.",
      "documents.downloadToView": "قم بتنزيل الملف لعرضه.",

      // Activities
      "activities.title": "الأنشطة",
      "activities.add": "إضافة نشاط",
      "activities.dueDate": "تاريخ الاستحقاق",
      "activities.noActivities": "لا توجد أنشطة",

      // Auth (2FA & Password Reset)
      "auth.2faError": "خطأ في التحقق الثنائي",
      "auth.2faPrompt": "تم إرسال رمز التحقق إلى بريدك الإلكتروني. يرجى إدخاله أدناه.",
      "auth.verificationCode": "رمز التحقق",
      "auth.verify": "تحقق",
      "auth.forgotPassword": "نسيت كلمة المرور؟",
      "auth.forgotPasswordDesc": "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين",
      "auth.forgotPasswordError": "خطأ في إرسال الرابط",
      "auth.sendResetLink": "إرسال الرابط",
      "auth.resetLinkSent": "تم إرسال رابط إعادة التعيين",
      "auth.checkEmail": "تحقق من بريدك الإلكتروني",
      "auth.backToLogin": "العودة لتسجيل الدخول",
      "auth.resetPassword": "إعادة تعيين كلمة المرور",
      "auth.resetPasswordDesc": "أدخل كلمة المرور الجديدة",
      "auth.resetPasswordError": "خطأ في إعادة التعيين",
      "auth.newPassword": "كلمة المرور الجديدة",
      "auth.confirmPassword": "تأكيد كلمة المرور",
      "auth.passwordRequirements": "12 حرفاً كحد أدنى",
      "auth.passwordTooShort": "كلمة المرور قصيرة جداً",
      "auth.passwordsDoNotMatch": "كلمات المرور غير متطابقة",
      "auth.passwordResetSuccess": "تم إعادة تعيين كلمة المرور بنجاح",
      "auth.redirectingToLogin": "جارٍ التحويل لتسجيل الدخول...",
      "auth.email": "البريد الإلكتروني",

      // Admin additional
      "admin.2faEnabled": "تم تفعيل 2FA لـ {{username}}",
      "admin.2faDisabled": "تم تعطيل 2FA لـ {{username}}",
      "admin.2faToggleError": "خطأ في تغيير 2FA",
      "admin.enable2FA": "تفعيل 2FA",
      "admin.disable2FA": "تعطيل 2FA",
      "admin.confirmPassword": "تأكيد كلمة المرور",
      "admin.confirmSendResetLink": "إرسال رابط إعادة التعيين إلى {{email}}؟",
      "admin.newPassword": "كلمة المرور الجديدة",
      "admin.passwordMismatch": "كلمات المرور غير متطابقة",
      "admin.passwordRequired": "كلمة المرور مطلوبة",
      "admin.passwordTooShort": "كلمة المرور قصيرة جداً",
      "admin.passwordUpdated": "تم تحديث كلمة المرور لـ {{username}}",
      "admin.passwordUpdateError": "خطأ في تحديث كلمة المرور",
      "admin.resetPassword": "إعادة تعيين كلمة المرور",
      "admin.resetPasswordTitle": "إعادة تعيين كلمة المرور",
      "admin.resetPasswordDesc": "تعيين كلمة مرور جديدة لـ: {{username}}",
      "admin.resetLinkSent": "تم إرسال رابط إعادة التعيين إلى {{email}}",
      "admin.resetLinkError": "خطأ في إرسال الرابط",
      "admin.sendResetLink": "إرسال رابط إعادة التعيين",
      "admin.setPassword": "تعيين كلمة المرور",
      "admin.testEmailConfig": "اختبار إعدادات البريد",
      "admin.testEmailDesc": "إرسال بريد تجريبي للتحقق من إعدادات SMTP",
      "admin.testEmailRecipient": "البريد المستلم",
      "admin.enterTestEmail": "أدخل البريد التجريبي",
      "admin.frontendUrl": "رابط الواجهة",
      "admin.frontendUrlDesc": "الرابط الأساسي للروابط في رسائل البريد",

      // Audit
      "audit.title": "سجل التدقيق",

      // Cases additional
      "cases.activityLog": "سجل الأنشطة",
      "cases.activityTitle": "العنوان",
      "cases.activityType": "النوع",
      "cases.activityDate": "التاريخ",
      "cases.activityDescription": "الوصف",
      "cases.addActivity": "إضافة نشاط",
      "cases.addComment": "إضافة تعليق",
      "cases.addNote": "إضافة ملاحظة",
      "cases.addTask": "إضافة مهمة",
      "cases.assignee": "المكلف",
      "cases.closedDate": "تاريخ الإغلاق",
      "cases.comment": "تعليق",
      "cases.comments": "التعليقات",
      "cases.currentStage": "المرحلة الحالية",
      "cases.dueDate": "تاريخ الاستحقاق",
      "cases.followUp": "متابعة",
      "cases.meeting": "اجتماع",
      "cases.message": "رسالة",
      "cases.noActivities": "لا توجد أنشطة",
      "cases.noActivity": "لا يوجد نشاط",
      "cases.noComments": "لا توجد تعليقات",
      "cases.noTasks": "لا توجد مهام",
      "cases.notFound": "القضية غير موجودة",
      "cases.note": "ملاحظة",
      "cases.noteType": "نوع الملاحظة",
      "cases.openedDate": "تاريخ الفتح",
      "cases.reminder": "تذكير",
      "cases.saveStage": "حفظ المرحلة",
      "cases.schedule": "جدولة",
      "cases.stage": "المرحلة",
      "cases.taskDescription": "وصف المهمة",
      "cases.taskTitle": "عنوان المهمة",
      "cases.tasks": "المهام",
      "cases.transitionCommentTitle": "تعليق الانتقال",
      "cases.transitionCommentMessage": "أضف تعليقاً لهذا الانتقال",
      "cases.updateStage": "تحديث المرحلة",
      "cases.workflow": "سير العمل",
      "cases.availableTransitions": "الانتقالات المتاحة",
      "cases.moveTo": "الانتقال إلى",
      "cases.requiresComment": "تعليق مطلوب",
      "cases.details": "تفاصيل القضية",
      "cases.stageChanged": "تم تغيير المرحلة إلى {{stage}}",
      "cases.stageChangeError": "خطأ في تغيير المرحلة",
      "cases.edit": "تعديل القضية",
      "cases.updated": "تم تحديث القضية بنجاح",
      "cases.loadError": "خطأ في تحميل القضية",
      "cases.assignedTo": "مسند إلى",

      // Common additional
      "common.active": "نشط",
      "common.inactive": "غير نشط",
      "common.addComment": "إضافة تعليق",
      "common.allStages": "جميع المراحل",
      "common.back": "رجوع",
      "common.comment": "تعليق",
      "common.confirm": "تأكيد",
      "common.filterByStage": "تصفية حسب المرحلة",
      "common.itemsPerPage": "العناصر في الصفحة",
      "common.next": "التالي",
      "common.previous": "السابق",
      "common.results": "نتائج",
      "common.showing": "عرض",
      "common.noDescription": "لا يوجد وصف",
      "common.noMatchingData": "لا توجد بيانات مطابقة",
      "common.unassigned": "غير مكلف",
      "common.unknown": "غير معروف",
      "common.system": "النظام",

      // Audit Actions
      "audit.actionCreate": "إنشاء",
      "audit.actionUpdate": "تعديل",
      "audit.actionDelete": "حذف",
      "audit.actionView": "عرض",

      // Module titles
      "foncier": "الأملاك العقارية",
      "contentieux": "المنازعات",
      "assurances": "التأمينات",
      "contrats": "العقود",

      // Contentieux additional
      "contentieux.nextHearingDate": "الجلسة القادمة",

      // Tasks
      "tasks.statusOpen": "مفتوح",
      "tasks.statusInProgress": "قيد التنفيذ",
      "tasks.statusCompleted": "مكتمل",

      // Status
      "status.open": "مفتوح",
      "status.inProgress": "قيد التنفيذ",
      "status.pending": "قيد الانتظار",
      "status.closed": "مغلق",

      // Cases Kanban
      "cases.kanban": "لوحة كانبان للقضايا",

      // Document Categories
      "documents.categoryGeneral": "عام",
      "documents.categoryCase": "قضية",
      "documents.categoryContract": "عقد",
      "documents.categoryAudit": "تدقيق",
      "documents.categoryOther": "أخرى",

      // Permissions
      "permissions.viewDashboard": "عرض لوحة القيادة",
      "permissions.viewCases": "عرض القضايا",
      "permissions.createCases": "إنشاء قضايا",
      "permissions.editCases": "تعديل القضايا",
      "permissions.deleteCases": "حذف القضايا",
      "permissions.viewFoncier": "عرض الأملاك العقارية",
      "permissions.createFoncier": "إنشاء سجلات عقارية",
      "permissions.editFoncier": "تعديل السجلات العقارية",
      "permissions.deleteFoncier": "حذف السجلات العقارية",
      "permissions.viewContentieux": "عرض المنازعات",
      "permissions.createContentieux": "إنشاء سجلات منازعات",
      "permissions.editContentieux": "تعديل سجلات المنازعات",
      "permissions.deleteContentieux": "حذف سجلات المنازعات",
      "permissions.viewAssurances": "عرض التأمينات",
      "permissions.createAssurances": "إنشاء سجلات تأمينات",
      "permissions.editAssurances": "تعديل سجلات التأمينات",
      "permissions.deleteAssurances": "حذف سجلات التأمينات",
      "permissions.viewContrats": "عرض العقود",
      "permissions.createContrats": "إنشاء سجلات عقود",
      "permissions.editContrats": "تعديل سجلات العقود",
      "permissions.deleteContrats": "حذف سجلات العقود",
      "permissions.viewDocuments": "عرض المستندات",
      "permissions.uploadDocuments": "رفع المستندات",
      "permissions.deleteDocuments": "حذف المستندات",
      "permissions.viewWorkflows": "عرض سير العمل",
      "permissions.createWorkflows": "إنشاء سير عمل",
      "permissions.editWorkflows": "تعديل سير العمل",
      "permissions.deleteWorkflows": "حذف سير العمل",
      "permissions.manageStages": "إدارة المراحل",
      "permissions.manageTransitions": "إدارة الانتقالات",
      "permissions.accessAdmin": "الوصول لإعدادات الإدارة",
      "permissions.manageUsers": "إدارة المستخدمين",
      "permissions.manageRoles": "إدارة الأدوار",
      "permissions.resetPassword": "إعادة تعيين كلمة المرور مباشرة",
      "permissions.sendResetLink": "إرسال رابط إعادة التعيين",
      "permissions.managePermissions": "إدارة الصلاحيات",

      // Profile
      "profile.title": "الملف الشخصي",
      "profile.description": "إدارة معلوماتك الشخصية",
      "profile.accountInfo": "معلومات الحساب",
      "profile.accountStatus": "حالة الحساب",
      "profile.email": "البريد الإلكتروني",
      "profile.phone": "الهاتف",
      "profile.department": "القسم",
      "profile.role": "الدور",
      "profile.lastLogin": "آخر تسجيل دخول",
      "profile.active": "نشط",
      "profile.inactive": "غير نشط",
      "profile.enabled": "مفعل",
      "profile.disabled": "معطل",
      "profile.enable": "تفعيل",
      "profile.disable": "تعطيل",
      "profile.twoFactorAuth": "المصادقة الثنائية",
      "profile.twoFactorStatus": "حالة 2FA",
      "profile.2faEnabled": "2FA مفعلة",
      "profile.2faEnabledDesc": "حسابك محمي بالمصادقة الثنائية",
      "profile.2faDisabled": "2FA معطلة",
      "profile.2faDisabledDesc": "فعّل 2FA لمزيد من الأمان",
      "profile.2faActive": "2FA نشطة",
      "profile.2faActiveDesc": "الحماية الإضافية مفعلة",
      "profile.2faError": "خطأ في تغيير 2FA",
      "profile.emailVerification": "التحقق من البريد الإلكتروني",

      // Workflows
      "workflows.title": "سير العمل",
      "workflows.management": "إدارة سير العمل",
      "workflows.list": "قائمة سير العمل",
      "workflows.create": "إنشاء سير عمل",
      "workflows.name": "الاسم",
      "workflows.nameFr": "الاسم (FR)",
      "workflows.nameAr": "الاسم (AR)",
      "workflows.description": "الوصف",
      "workflows.entityType": "نوع الكيان",
      "workflows.status": "الحالة",
      "workflows.stages": "المراحل",
      "workflows.transitions": "الانتقالات",
      "workflows.addStage": "إضافة مرحلة",
      "workflows.editStage": "تعديل المرحلة",
      "workflows.addTransition": "إضافة انتقال",
      "workflows.editTransition": "تعديل الانتقال",
      "workflows.stageCode": "رمز المرحلة",
      "workflows.color": "اللون",
      "workflows.order": "الترتيب",
      "workflows.initial": "ابتدائي",
      "workflows.final": "نهائي",
      "workflows.folded": "مطوي",
      "workflows.isInitial": "هو ابتدائي",
      "workflows.isFinal": "هو نهائي",
      "workflows.isFolded": "هو مطوي",
      "workflows.fromStage": "من المرحلة",
      "workflows.toStage": "إلى المرحلة",
      "workflows.requiresComment": "يتطلب تعليق",
      "workflows.requiresAttachments": "يتطلب مرفقات",
      "workflows.noStages": "لا توجد مراحل",
      "workflows.noTransitions": "لا توجد انتقالات",
      "workflows.confirmDeleteStage": "حذف هذه المرحلة؟",
      "workflows.confirmDeleteTransition": "حذف هذا الانتقال؟",
      "workflows.stageCreated": "تم إنشاء المرحلة",
      "workflows.stageUpdated": "تم تحديث المرحلة",
      "workflows.stageDeleted": "تم حذف المرحلة",
      "workflows.stageReordered": "تم إعادة ترتيب المراحل",
      "workflows.transitionCreated": "تم إنشاء الانتقال",
      "workflows.transitionUpdated": "تم تحديث الانتقال",
      "workflows.transitionDeleted": "تم حذف الانتقال",
      "workflows.notFound": "سير العمل غير موجود",
      "workflows.info": "معلومات",
      "workflows.info1": "سير العمل يحدد دورة حياة القضايا",
      "workflows.info2": "كل مرحلة تمثل حالة للقضية",
      "workflows.info3": "الانتقالات تحدد المسارات الممكنة بين المراحل",
      "workflows.info4": "ترتيب المراحل يحدد طريقة عرضها",

      // Colors
      "colors.gray": "رمادي",
      "colors.red": "أحمر",
      "colors.orange": "برتقالي",
      "colors.yellow": "أصفر",
      "colors.green": "أخضر",
      "colors.blue": "أزرق",
      "colors.indigo": "نيلي",
      "colors.purple": "بنفسجي",
      "colors.pink": "وردي"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
